import { RootState } from '../../../base';

export const dashboardSelectors = {
    getIsLoadingStats: (state: RootState) =>
        state.dashboard.uiState.isLoadingStats,
    getStats: (state: RootState) => state.dashboard.stats,
    getLastUpdated: (state: RootState) => state.dashboard.lastUpdated,
    getIsLoadingNotifications: (state: RootState) =>
        state.dashboard.uiState.isLoadingNotifications,
    getNotifications: (state: RootState) => state.dashboard.notifications,
    getIsUpdatingNotifications: (state: RootState) =>
        state.dashboard.uiState.isUpdatingNotifications,
    getIsLoadingAssignments: (state: RootState) =>
        state.dashboard.uiState.isLoadingAssignments,
    getAssignments: (state: RootState) => state.dashboard.assignments,
    getCompletedAssignments: (state: RootState) =>
        state.dashboard.completedAssignments,
    getIsUpdatingAssignment: (state: RootState) =>
        state.dashboard.uiState.isUpdatingAssignment,
    getTrackableStatistics: (state: RootState) =>
        state.dashboard.trackableStatistics,
    getIsLoadingTrackableStatistics: (state: RootState) =>
        state.dashboard.uiState.isLoadingTrackableStatistics,
};
